/* istanbul ignore file */

import { AppFeatureMetrics } from '../../../models';

export class FeatureUsageLogicServiceModel {
    appFeatureMetrics: AppFeatureMetrics[] = [];
    pageSizes = [25, 50, 100];
}
